import { createAsyncThunk } from "@reduxjs/toolkit";

import { type CustomInvoicesClient } from "@fitness-app/data-models/entities/Product";
import { getErrorMessage } from "@fitness-app/utils";

import { getLoggedUser } from "../../../helpers/getLoggedUser";
import { type ActionParams, type AsyncThunkCreator } from "../../../index";
import { PRODUCTS_REDUCER_NAME } from "../types";

export interface DuplicateProductPayload {
  sourceProductId: string;
  name?: string;
  description?: string;
  images?: string[];
  customStripeAccount?: string | null;
  tpayIntegration?: string | null;
  customInvoicesClient?: CustomInvoicesClient | null;
}

export const duplicateProduct = createAsyncThunk<
  void,
  ActionParams<DuplicateProductPayload>,
  AsyncThunkCreator<string>
>(
  `${PRODUCTS_REDUCER_NAME}/duplicateProduct`,
  async ({ payload, onSuccess, onFailure }, { rejectWithValue, extra: { analytics, auth, productApi } }) => {
    try {
      await getLoggedUser(auth);

      await productApi.post("/duplicate-product", payload);
      analytics.track("duplicated_product", {
        sourceProductId: payload.sourceProductId,
      });
      onSuccess?.();
    } catch (e) {
      onFailure?.();

      return rejectWithValue(getErrorMessage(e));
    }
  },
);
